class NumberInput {

    constructor() {
        $('input[type="number"]').on('change', e => {
            const target = e.currentTarget;
            const min = +target.getAttribute('min') || Number.MIN_SAFE_INTEGER;
            const max = +target.getAttribute('max') || Number.MAX_SAFE_INTEGER;

            if (target.value) {
                target.value = Math.max(target.value, min);
                target.value = Math.min(target.value, max);
            }
        });
    }

}
